var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScrollDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 23",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.944 22.69l6.73-6.731c.204-.203.265-.196.155-.462-.11-.265-.37-.126-.657-.126h-4.74V1.895C9.433.849 8.48 0 7.433 0c-1.046 0-2 .849-2 1.895V15.37H.712c-.287 0-.546-.14-.656.126-.037.088-.055.024-.055.116 0 .185.073.289.209.424l6.73 6.692c.278.278.728.239 1.005-.04",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

export default SvgScrollDown;